<div class="sw-cms-el-config-moorl-contact">
    <sw-cms-mapping-field
        v-model:config="element.config.email"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.email')"
            v-model="element.config.email.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.phoneNumber"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.phoneNumber')"
            v-model="element.config.phoneNumber.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.shopUrl"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.shopUrl')"
            v-model="element.config.shopUrl.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.merchantUrl"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.merchantUrl')"
            v-model="element.config.merchantUrl.value"
        />
    </sw-cms-mapping-field>
</div>